import { Theme } from '@mui/material'

const classes = {
  tabs: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
    borderRadius: 100,
    width: '100%',
    '& .MuiTabs-indicator': { display: 'none' },
  }),
  tab: (theme: Theme) => ({
    borderRadius: 100,
    textTransform: 'none',
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  }),
  tabPanel: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceBright,
    borderRadius: 1.5,
  }),
  skeletonRoot: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    height: '100%',
    border: '1px solid #00000014',
    borderRadius: '8px',
    p: 2,
  }),
  skeletonContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  skeletonYAxisLabels: {
    position: 'absolute',
    left: 0,
    top: 20,
    bottom: 48 + 65,
    width: 36,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  skeletonPlotFrame: {
    position: 'absolute',
    left: 44,
    right: 8,
    top: 8,
    bottom: 48 + 65,
    borderLeft: '1px solid #00000014',
    borderBottom: '1px solid #00000014',
    borderRadius: '0 0 0 8px',
  },
  skeletonGridLine: (row: number) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: `${(row + 1) * 20}%`,
    height: '1px',
    transform: 'translateY(-0.5px)',
  }),
  skeletonSvgWrapper: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '14%',
    bottom: 'calc(12% + 60px)',
  },
  skeletonSvg: {
    width: '100%',
    height: '100%',
  },
  skeletonMiddleBarContainer: {
    position: 'absolute',
    left: 44,
    right: 8,
    bottom: 65,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skeletonMiddleBar: {
    backgroundColor: '#00000010',
  },
  skeletonBottomLabels: {
    position: 'absolute',
    left: 44,
    right: 8,
    bottom: 8,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chartContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '400px',
  },
  chartErrorImage: {
    width: '80%',
  },
  baseChartContainer: {
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  customTabPanelContent: {
    p: 1,
  },
}

export default classes
